/* Altera Reviews — Product card mini-star ratings.
   Fetches per-product aggregates once, caches in localStorage for 15 min,
   and injects tiny star + count under each product card title.

   Handles all Altera card layouts (collection cards, shop-by-use tabbed
   cards, small prod cards, default product-blocks). Uses MutationObserver
   so cards added dynamically (tab switches, load-more) also get stars. */
(function () {
  'use strict';

  var WORKER_URL = (window.AlteraWishlistBoot && window.AlteraWishlistBoot.workerUrl)
    || 'https://mel-worker.melbel1313.workers.dev';
  var AGGREGATES_URL = WORKER_URL + '/api/reviews/aggregates';
  var CACHE_KEY = 'altera_reviews_aggregates_v1';
  var CACHE_TTL_MS = 15 * 60 * 1000;

  var aggregates = null;

  function readCache() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.ts || !parsed.data) return null;
      if (Date.now() - parsed.ts > CACHE_TTL_MS) return null;
      return parsed.data;
    } catch (e) { return null; }
  }

  function writeCache(data) {
    try { localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), data: data })); }
    catch (e) {}
  }

  function loadAggregates() {
    if (aggregates) return Promise.resolve(aggregates);
    var cached = readCache();
    if (cached) {
      aggregates = cached;
      // Background refresh
      fetch(AGGREGATES_URL)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.ok && d.aggregates) {
            aggregates = d.aggregates;
            writeCache(d.aggregates);
          }
        })
        .catch(function () {});
      return Promise.resolve(aggregates);
    }
    return fetch(AGGREGATES_URL)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.ok && d.aggregates) {
          aggregates = d.aggregates;
          writeCache(d.aggregates);
          return aggregates;
        }
        aggregates = {};
        return aggregates;
      })
      .catch(function () {
        aggregates = {};
        return aggregates;
      });
  }

  function extractHandle(href) {
    if (!href) return null;
    var m = String(href).match(/\/products\/([^\/?#]+)/);
    return m ? m[1].toLowerCase() : null;
  }

  function starsHtml(rating) {
    var v = Math.max(0, Math.min(5, +rating || 0));
    var pct = (v / 5) * 100;
    return '<span class="altera-mini-star-wrap">★★★★★' +
           '<span class="altera-mini-star-fill" style="width:' + pct + '%;">★★★★★</span>' +
           '</span>';
  }

  function buildStarsEl(agg) {
    var el = document.createElement('div');
    el.className = 'altera-mini-stars';
    el.setAttribute('data-altera-stars', '1');
    el.innerHTML = starsHtml(agg.avg_rating) +
      '<span class="altera-mini-count">(' + agg.count + ')</span>';
    return el;
  }

  // Card layouts we know about, mapped to the element after which stars appear.
  //
  // NOTE: '.product-block' (theme's native product card) is intentionally NOT
  // in this list. On those cards we render reviews server-side via the native
  // Shopify metafield (product-block.liquid line 262, using
  // product.metafields.reviews.rating_count) — that renders faster, works
  // without JS, and emits SEO structured data. The Mel Worker
  // /api/reviews/sync-metafields cron keeps that metafield fresh (~hourly).
  // If both this JS AND the metafield rendered, users saw double star badges.
  var CARD_SELECTORS = [
    { card: '.altera-coll-tabbed-card', afterTitleIn: '.altera-coll-tabbed-card-title' },
    { card: '.altera-coll-card',        afterTitleIn: '.altera-coll-card-title' },
    { card: '.altera-coll-prod',        afterTitleIn: '.altera-coll-prod-title' },
  ];

  function findHrefOnCard(cardEl) {
    if (cardEl.tagName === 'A') return cardEl.getAttribute('href');
    var link = cardEl.querySelector('a[href*="/products/"]');
    return link ? link.getAttribute('href') : null;
  }

  function injectStars() {
    if (!aggregates) return;
    for (var i = 0; i < CARD_SELECTORS.length; i++) {
      var spec = CARD_SELECTORS[i];
      var cards = document.querySelectorAll(spec.card);
      for (var j = 0; j < cards.length; j++) {
        var card = cards[j];
        if (card.querySelector('[data-altera-stars]')) continue;
        var href = findHrefOnCard(card);
        var handle = extractHandle(href);
        if (!handle) continue;
        var agg = aggregates[handle];
        if (!agg || !agg.count) continue;

        var anchor = spec.afterTitleIn ? card.querySelector(spec.afterTitleIn) : null;
        var stars = buildStarsEl(agg);
        if (anchor && anchor.parentNode) {
          anchor.parentNode.insertBefore(stars, anchor.nextSibling);
        } else {
          card.appendChild(stars);
        }
      }
    }
  }

  function extractHandleFromUrl() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1].toLowerCase() : null;
  }

  function injectPdpHeaderRating() {
    if (!aggregates) return;
    if (document.querySelector('[data-altera-pdp-rating]')) return;

    // Only inject on product pages
    var title = document.querySelector('h1.altera-pdp-title');
    if (!title) return;

    var handle = extractHandleFromUrl();
    if (!handle) return;
    var agg = aggregates[handle];
    if (!agg || !agg.count) return;

    var rating = document.createElement('a');
    rating.href = '#altera-reviews';
    rating.className = 'altera-pdp-rating';
    rating.setAttribute('data-altera-pdp-rating', '1');
    rating.innerHTML =
      starsHtml(agg.avg_rating) +
      '<span class="altera-pdp-rating-count">' + agg.count + ' Review' + (agg.count === 1 ? '' : 's') + '</span>';

    rating.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.getElementById('altera-reviews');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    title.parentNode.insertBefore(rating, title.nextSibling);
  }

  function init() {
    loadAggregates().then(function () {
      injectStars();
      injectPdpHeaderRating();
      if (typeof MutationObserver !== 'undefined') {
        var mo = new MutationObserver(function () {
          injectStars();
          injectPdpHeaderRating();
        });
        mo.observe(document.body, { childList: true, subtree: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
